import { ILocaleKey } from "@faire/web-api/indigofair/locale/ILocaleKey";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const getAvailableLanguageSelectorLocales = () =>
  getGlobalProperty<ILocaleKey[]>("availableLanguageSelectorLocales") ?? [];
